import DOMPurify from 'dompurify'
import parse from 'html-react-parser'

export const sanitazeHtml = (htmlString: string) => {
  const cleanHtmlString = DOMPurify.sanitize(htmlString, { USE_PROFILES: { html: true } })
  return parse(cleanHtmlString)
}
